module.exports = __webpack_public_path__ + "img/image_7.af16f7f4.jpg";